class SliderCard extends HTMLElement {
    _refs = {
        triggers: [],
        targets: []
    }

    _swiper = null
    _media = null

    is_mobile = false

    connectedCallback()
    {
        this._media = window.matchMedia("(max-width: 990px)")

        this._refs.triggers = Array.from( this.querySelectorAll("[data-slider-card-for]") )
        this._refs.targets = Array.from( this.querySelectorAll("[data-slider-card-id]") )

        this.is_mobile = this._media.matches

        this.is_mobile
            && this.init()

        this._media.addEventListener("change", event => {
            this.is_mobile = event.matches;

            this.is_mobile
                ? this.init()
                : this._swiper?.destroy()
        })

        this._refs.triggers.forEach(trigger => 
            trigger.addEventListener("click", () => this
                .toggle(trigger)
                    .then(() => 
                        this.is_mobile 
                            && this.init()
                    )
                )
        )
    }

    init()
    {
        this._swiper?.destroy()
        this._swiper = new Swiper('.slider-card-products.active', { slidesPerView: "auto" })
    }

    toggle( element )
    {
        return new Promise((resolve) => {
            const is_active = element.classList.contains('active');
            if( is_active ) return;

            const attr = element.getAttribute("data-slider-card-for");
            if( ! attr ) return;

            const target = this._refs.targets.find(x => x.getAttribute("data-slider-card-id") === attr);
            if( ! target ) return;

            this._refs.triggers.forEach(x => x.classList.remove('active'))
            this._refs.targets.forEach(x => x.classList.remove('active'))

            const batch = [element, target]
            batch.forEach(x => x.classList.add('active'))

            resolve()
        })
    }

    disconnectCallback()
    {
    }
}

customElements.define('slider-card', SliderCard);